















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import RestaurantModule from "@/store/restaurant";
import OrderModule from "@/store/order";
import UGCViewer from "@/components/UGCViewer.vue";
import Pagination from "@/components/Pagination.vue";
import CTooltip from "@/components/CTooltip.vue";
import { asyncMap, truncate } from "@/utils/Util";
import { RestaurantsApi } from "@/services/api-service";
import { AxiosResponse } from "axios";
import { edDays } from "@/types";
import { EnvelopedPaginatedMenuList, Menu, OrderDetail } from "../api";

@Component({
  components: {
    UGCViewer,
    Pagination,
    CTooltip,
  },
})
export default class RestaurantList extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formattedRestaurants: any = [];

  private get restaurants() {
    return RestaurantModule.restaurants;
  }

  private get edDays() {
    return edDays;
  }

  private get getDay() {
    const day = new Date().getDay();
    const days = ["日", "月", "火", "水", "木", "金", "土"];
    return days[day];
  }

  private get isAddedCart() {
    return OrderModule.isAddedCart ? OrderModule.isAddedCart : false;
  }

  private truncateName(name: string) {
    const len = 18;
    return truncate(name, len);
  }

  @Watch("restaurants")
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private async mergeCounter(restaurants: any) {
    if (!(restaurants.length > 0)) {
      this.formattedRestaurants = [];
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.formattedRestaurants = await asyncMap(restaurants, async (restaurant: any) => {
      if (restaurant.menus && restaurant.menus.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: AxiosResponse<EnvelopedPaginatedMenuList> = await RestaurantsApi.instance.getMenusByRestaurantUuid(
          restaurant.uuid,
          4,
          false
        );
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const limitMenus: any = res.data.data?.items;
        const menus = await asyncMap(limitMenus, async (menu: Menu) => {
          return { ...menu, amount: 1 };
        });
        return { ...restaurant, menus };
      }
      return { ...restaurant };
    });
  }

  private async addCart(menu: Menu & { amount: number; isAddedCart?: boolean }) {
    const orderDetail = {
      menuUuid: menu.uuid,
      quantity: menu.amount,
    } as OrderDetail;

    OrderModule.commitAddOrderDetail({
      restaurantUuid: menu.restaurantUuid,
      orderDetail,
    });
    this.mergeCounter(this.restaurants);
    // eslint-disable-next-line no-param-reassign
    OrderModule.commitIsAddedCart(true);
    setTimeout(() => {
      // eslint-disable-next-line no-param-reassign
      OrderModule.commitIsAddedCart(false);
    }, 3000);
  }

  private mounted() {
    OrderModule.commitIsAddedCart(false);
    this.mergeCounter(this.restaurants);
  }
}
